import { connect } from 'react-redux';
import { getQuestionnaireEvaluationQuestionAttributeType } from "../../questionnaireEvaluation";
import { PhotoCaptureDamagePanelComponent } from '../components/PhotoCaptureDamagePanelComponent';
import { getMaxChildDamagePanelCount, getPhotoCaptreIsFileUploadStarted, getPhotoCaptureCompanyCode, getPhotoCaptureDisableLibrary, getPhotoCaptureFileSizeLimit, getPhotoCaptureImageMaxWidth, getShouldAllowMitchellIntelligent } from '../selectors';
import { photoCaptureIntelligentProgressiveImageMiscAction, photoCaptureIntelligentViewChangeAction } from '../actions';
const mapStateToProps = (state, ownProps) => {
    return {
        companyCode: getPhotoCaptureCompanyCode(state),
        isFileUploadStarted: getPhotoCaptreIsFileUploadStarted(state),
        imageMaxWidth: getPhotoCaptureImageMaxWidth(state),
        disableLibrary: getPhotoCaptureDisableLibrary(state),
        fileSizeLimit: getPhotoCaptureFileSizeLimit(state),
        maxChildDamagePanelCount: getMaxChildDamagePanelCount(state),
        questionSubType: getQuestionnaireEvaluationQuestionAttributeType(state),
        isMic: getShouldAllowMitchellIntelligent(state)
    };
};
const mapDispatchToProps = (dispatch) => ({
    onViewChange: (view, sequenceScreenName) => {
        dispatch(photoCaptureIntelligentViewChangeAction(view, sequenceScreenName));
    },
    onMicPRGMiscDetails: (payload) => {
        dispatch(photoCaptureIntelligentProgressiveImageMiscAction(payload));
    }
});
export const ConnectedPhotoCaptureDamagePanelContainer = connect(mapStateToProps, mapDispatchToProps)(PhotoCaptureDamagePanelComponent);
//# sourceMappingURL=ConnectedPhotoCaptureDamagePanelContainer.js.map